import { render, staticRenderFns } from "./Domestic.vue?vue&type=template&id=23a0dd8c&scoped=true"
import script from "./Domestic.vue?vue&type=script&lang=js"
export * from "./Domestic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a0dd8c",
  null
  
)

export default component.exports